import { render, staticRenderFns } from "./CancelDeliveryAction.vue?vue&type=template&id=5cea70aa&"
import script from "./CancelDeliveryAction.vue?vue&type=script&lang=js&"
export * from "./CancelDeliveryAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports